import styled from 'styled-components'
import { SharedWrapper } from 'components/shared/RadioButtons/styles'
import { respondAbove } from 'styles/mediaQueries'

interface WrapperProps {
    isChecked: boolean
}

export const Wrapper = styled(SharedWrapper)<WrapperProps>`
    width: 100%;
    height: 172px;
    padding: 16px;

    @media ${respondAbove.xl} {
        height: 224px;
        padding: 24px 16px;
    }

    img {
        height: 30px;

        @media ${respondAbove.xl} {
            height: 42px;
        }
    }
`
